import { useState } from "react"
import { fetchApi } from "../helpers"

const usePlanes = (url, headers, value) => {
    const [planes, setPlanes] = useState([])
    
    const handlePlanes = async (Idsede, setFieldValue) => {
 
        setFieldValue(value, Idsede)
        setFieldValue("IdCarrera", "")
        setFieldValue("IdGrado", "")

        try {
            const res = await fetchApi({
                url: url + '/utils/busquedas',
                headers,
                content: {
                    opcion: "PLANES",
                    Idsede: Idsede
                }
            })
            setPlanes(res)
        } catch (err) {
            console.log(err)
        }
    }

    return [planes, handlePlanes]
}

export {
    usePlanes
}